import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class AuthJwtService {

  private pathAPI = environment.urlAPI;
  private authenticationChanged = new Subject<boolean>();

  constructor(private http: HttpClient) {
  }

  public login(body: any): Observable<any> {
    let urlToken = this.pathAPI + 'Login';    
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenStihlPt.length > 0) {
          this.setStorageToken(res.tokenStihlPt);
          this.setStorageRefreshToken(res.refreshTokenStihlPt);
        }
      })
    );
  }

  public refreshToken(body: any): Observable<any> {

    let urlToken = this.pathAPI + 'Login/Refresh';
    return this.http.post<any>(urlToken, body).pipe(
      tap(async (res: any) => {
        if (res.tokenStihlPt.length > 0) {
          this.setStorageToken(res.tokenStihlPt);
          this.setStorageRefreshToken(res.refreshTokenStihlPt);
        }
      })
    );
  }

  public logout(): void {
    this.setStorageToken(undefined);
  }

  public setToken(data: any): void {
    this.setStorageToken(data.tokenStihlPt);
    this.setStorageRefreshToken(data.refreshTokenStihlPt);
  }

  private setStorageToken(value: any): void {
    window.localStorage['tokenStihlPt'] = value;
    this.authenticationChanged.next(this.isAuthenticated());
  }

  private setStorageRefreshToken(value: any): void {
    window.localStorage['refreshTokenStihlPt'] = value;
  }

  public isAuthenticated(): boolean {
    return (!(window.localStorage['tokenStihlPt'] === undefined ||
      window.localStorage['tokenStihlPt'] === null ||
      window.localStorage['tokenStihlPt'] === 'null' ||
      window.localStorage['tokenStihlPt'] === 'undefined' ||
      window.localStorage['tokenStihlPt'] === ''));
  }

  public isAuthenticationChanged(): any {
    return this.authenticationChanged.asObservable();
  }

  public getToken(): any {
    if (window.localStorage['tokenStihlPt'] === undefined ||
      window.localStorage['tokenStihlPt'] === null ||
      window.localStorage['tokenStihlPt'] === 'null' ||
      window.localStorage['tokenStihlPt'] === 'undefined' ||
      window.localStorage['tokenStihlPt'] === '') {
      return '';
    }
    let obj = window.localStorage['tokenStihlPt'];
    return obj;
  }

  public getRefreshToken(): any {
    if (window.localStorage['refreshTokenStihlPt'] === undefined ||
      window.localStorage['refreshTokenStihlPt'] === null ||
      window.localStorage['refreshTokenStihlPt'] === 'null' ||
      window.localStorage['refreshTokenStihlPt'] === 'undefined' ||
      window.localStorage['refreshTokenStihlPt'] === '') {
      return '';
    }
    let obj = window.localStorage['refreshTokenStihlPt'];
    return obj;
  }

}
